<!-- Page banner Area -->
<div class="page-banner bg-6">
    <div class="d-table">
        <div class="d-table-cell">
            <div class="container">
                <div class="page-content service-banner-content">
                    <h2>Express Services</h2>
                    <ul>
                        <li><a routerLink="/">Home</a></li>
                        <li>Express Services</li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</div>
<!-- End Page banner Area -->

<div class="container-fluid mt-5 mb-5">
    <h1 class="mb-5 pb-2 border-bottom border-dark">Express Services</h1>
    <h3>Express Administrations : Better three hours as well before long than a miniature as well late !
    </h3>
    <p>We get it your require for speed.</p>
    <p>We use the existing shipping systems with a few of the biggest coordinations and shipping administrations
        suppliers within the USA and the world. We offer productive, cost-effective arrangements for your express
        shipping needs not fair over the 50 states, but over the landmasses through our universal conveyance
        administrations.

    </p>
    <p>From the primary mile to last-mile conveyance needs, we have arrangements that take the stress out of all sorts
        of coordinations prerequisites.</p>
    <h5>Domestic Express Services </h5>
    <p>At lemonmode, any client isnt fair an account number, we know each of our clients by their to begin with names.
        Our residential express administrations get your shipments express conveyed to any of the 50 states of the USA
        with customized administrations for another day, 2-day, another day am/pm, ground administrations, securely,
        dependably and financially.</p>
    <p>To include to it all, we are enchanted to serve you as your neighborly neighborhood conveyance benefit for your
        worldwide shipping needs as well!</p>
    <h1>Around the world benefit arrange Our Universal Conveyance Bundles</h1>
    <p>With our economy and express conveyance bundles for universal conveyances, we offer customized arrangements to
        discover a idealize adjust between budget and criticalness for you at an reasonable price.</p>
    <p>Our accomplice organize spread over all landmasses makes a difference you get the foremost compelling scope with
        Canada, UK, Europe, Brazil, Turkey, UAE, KSA, Singapore, and India well inside the reach of your commerce,
        advertising you a awesome esteem on shipping around the world.</p>
    <p>In brief, we offer you world-class shipping and coordinations arrangements at an extraordinary cost and
        immaculate
        benefit encounter!</p>
    <p>We guarantee a totally straightforward, trackable, and online handle of your bundle development. So that
        everybody included-from you, our accomplices, to the beneficiary, has real-time following overhauls at all
        times. We moreover offer traditions clearances and a wide run of non-standard send out and clearance
        administrations. Nitty gritty traditions data can be gotten to on <a
            href="https://www.lemonmode.us/a/Contact_US"></a> </p>
    <div class="express-features mb-4">
        <div class="d-flex align-items-center justify-content-center mb-3">
            <span class="express-section-pill">Domestic Express Services</span>
        </div>
        <div class="row g-3 g-lg-4 row-cols-2 row-cols-xl-4">
            <div class="col">
                <div class="express-feature-card h-100">
                    <div class="express-feature-icon">
                        <img src="assets/img/EXS-img-1.png" alt="air">
                    </div>
                    <div class="express-feature-title">Next Flight Out</div>
                    <div class="express-feature-line"></div>
                </div>
            </div>
            <div class="col">
                <div class="express-feature-card h-100">
                    <div class="express-feature-icon">
                        <img src="assets/img/EXS-img-2.png" alt="air">
                    </div>
                    <div class="express-feature-title">Overnight Freight Services</div>
                    <div class="express-feature-line"></div>
                </div>
            </div>
            <div class="col">
                <div class="express-feature-card h-100">
                    <div class="express-feature-icon">
                        <img src="assets/img/EXS-img-3.png" alt="air">
                    </div>
                    <div class="express-feature-title">Competitive Deferred Air Freight Service</div>
                    <div class="express-feature-line"></div>
                </div>
            </div>
            <div class="col">
                <div class="express-feature-card h-100">
                    <div class="express-feature-icon">
                        <img src="assets/img/EXS-img-4.png" alt="air">
                    </div>
                    <div class="express-feature-title">Time Definite Express Service</div>
                    <div class="express-feature-line"></div>
                </div>
            </div>
        </div>
    </div>

    <div class="express-chooser mb-4">
        <div class="express-chooser-title">Choose from :</div>
        <div class="row g-3">
            <div class="col-lg-6">
                <div class="express-choice-card">
                    <span class="express-choice-index">1</span>
                    <div class="express-choice-text">Priority - Overnight and Next Day air delivered by 10:30 am next
                        business day.</div>
                </div>
            </div>
            <div class="col-lg-6">
                <div class="express-choice-card">
                    <span class="express-choice-index">2</span>
                    <div class="express-choice-text">Standard - Overnight and Next Day Air Saver-delivered by 3.00p.m.
                        next business day.</div>
                </div>
            </div>
        </div>
    </div>

    <div class="d-flex align-items-center justify-content-center mb-3">
        <span class="express-section-pill">International Express Shipping</span>
    </div>
    <div class="express-features">
        <div class="row g-3 g-lg-4 row-cols-1 row-cols-md-3">
            <div class="col">
                <div class="express-feature-card h-100">
                    <div class="express-feature-icon">
                        <img src="assets/img/EXS-img-5.png" alt="air">
                    </div>
                    <div class="express-feature-title">Next Flight Out</div>
                    <div class="express-feature-line"></div>
                </div>
            </div>
            <div class="col">
                <div class="express-feature-card h-100">
                    <div class="express-feature-icon">
                        <img src="assets/img/EXS-img-6.png" alt="air">
                    </div>
                    <div class="express-feature-title">Overnight Freight Services</div>
                    <div class="express-feature-line"></div>
                </div>
            </div>
            <div class="col">
                <div class="express-feature-card h-100">
                    <div class="express-feature-icon">
                        <img src="assets/img/EXS-img-7.png" alt="air">
                    </div>
                    <div class="express-feature-title">Competitive Deferred Air Freight Service</div>
                    <div class="express-feature-line"></div>
                </div>
            </div>
        </div>
    </div>
</div>